<script setup lang="ts">
import HotelCard from '@components/util/hotel-card';
const { count = 1 } = defineProps<IProps>();
interface IProps {
    count?: number;
}
</script>

<template>
    <div class="card-loaders-list">
        <template v-for="key in count" :key>
            <HotelCard loading class="card-skeleton" />
        </template>
    </div>
</template>

<style lang="scss" scoped>
.card-skeleton {
    margin: 2px 0;
}
</style>
